export default __webpack_public_path__ + "7b0f0abf6008692a8f1114ee9e9b5554.png";